<template>
    <div>
        <b-table borderless :fields="bootstrapTable.fields" :items="data">
            <template v-slot:cell(code)="data">
                <span v-text="data.item.data.attributes.code"/>
            </template>

            <template v-slot:cell(name)="data">
                <router-link class="text-data-link" :to="data.item.links.self"
                             v-text="data.item.data.attributes.name"/>
            </template>

            <template v-slot:cell(ssn)="data">
                <span v-text="data.item.data.attributes.ssn"/>
            </template>

            <template v-slot:cell(dob)="data">
                <span v-text="data.item.data.attributes.dob"/>
            </template>

            <template v-slot:cell(status)="data">
                <b-badge pill :style="clientStatusWidth(data.item.data.attributes.status)"
                         :variant="clientStatus(data.item.data.attributes.status)"
                >{{ data.item.data.attributes.status }}
                </b-badge>
            </template>

            <template v-slot:cell(updated_by)="data">
                <span v-text="data.item.data.attributes.updated_by"/>
            </template>

            <template v-slot:cell(updated_at)="data">
                <span v-text="data.item.data.attributes.updated_at"/>
            </template>
        </b-table>
    </div>
</template>

<script>
    export default {
        name: "LatestClients",
        props: ['data'],
        data() {
            return {
                bootstrapTable: {
                    fields: [
                        {key: 'code', label: 'Code', tdClass: ''},
                        {key: 'name', label: 'Name', tdClass: ''},
                        {key: 'ssn', label: 'SSN', tdClass: 'text-muted'},
                        {key: 'dob', label: 'DOB', tdClass: 'text-muted'},
                        {key: 'status', label: 'Status', thClass: 'text-center', tdClass: 'text-center'},
                        {key: 'updated_by', label: 'Updated By', tdClass: 'text-muted'},
                        {key: 'updated_at', label: 'Updated At', tdClass: 'text-muted'},
                    ]
                }
            }
        },
        methods: {
            clientStatus(event) {
                if ((event).toLowerCase() === 'referral') {
                    return 'warning'
                } else if ((event).toLowerCase() === 'admitted') {
                    return 'success'
                } else if ((event).toLowerCase() === 'transferred') {
                    return 'info'
                } else if ((event).toLowerCase() === 'discharged') {
                    return 'secondary'
                } else if ((event).toLowerCase() === 'duplicate') {
                    return 'dark'
                } else {
                    return 'light'
                }
            },

            clientStatusWidth: status => {
                if (status.toLowerCase() === 'hospitalized - covid-19' ||
                    status.toLowerCase() === 'hospitalized - other') return 'width: 133px'

                else return 'width: 73px';
            },
        }
    }
</script>

<style scoped>

</style>
